(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.agendasettings');
    module.directive('weekschemeTable', [WeekschemesTableDirectiveFn]);

    /* week scheme table directive */
    function WeekschemesTableDirectiveFn() {
        var directive = {
            restrict: 'E',
            replace: true,
            templateUrl: '/app/settings/agendasettings/modules/weekschemes/templates/weekscheme-table.template.html',
            controller: 'WeekschemeTableController',
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                weekschemes: '=',
                individual: '@'
            }
        };
        return directive;


    }

})();